<div class="header">
    <div class="row">
      <div class="col-md">
        <h3>{{'DOC-DASHBOARD.DESHBOARD' | translate}}</h3>
        <h6>{{'CHART.TOTAL' | translate}}: {{emailTotal}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>
    </div>
  </div>


  <div class="row mr-0">

    <div class="col-6  d-flex flex-row">
      <div class="ts-box sentChart flex-column" [ngClass]="{'selected-ApproveChart': docType === 'ApproveChart'}"
           (click)="selectedType('sent', 'Approved')" style="overflow: hidden">
        <h5 class="text-center mt-2 mb-0">{{'TEXT.APPROVE-ACCOUNT' | translate}}</h5>
        <div class="canvas mt-4">
          <canvas id="ApproveChart">{{myChart1}}</canvas>
        </div>
        <h6 class="text-center mb-2">{{transactions_approve}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>

      <div class="ts-box errorsChart flex-column" [ngClass]="{'selected-RejectedChart': docType === 'RejectedChart'}"
           (click)="selectedType('errors', 'Rejected')" style="overflow: hidden">
        <h5 class="text-center mt-2 mb-0">{{'TEXT.REJECT-ACCOUNT' | translate}}</h5>
        <div class="canvas mt-4">
          <canvas id="RejectedChart">{{myChart2}}</canvas>
        </div>
        <h6 class="text-center mb-2">{{transactions_rejected}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>

       <div class="ts-box notSentChart flex-column" [ngClass]="{'selected-pendingChart': docType === 'pending'}"
           (click)="selectedType('errors', 'Pending')" style="overflow: hidden">
        <h5 class="text-center mt-2 mb-0">{{'TEXT.PENDING-ACCOUNT' | translate}}</h5>
        <div class="canvas mt-4">
          <canvas id="pendingChart">{{myChart3}}</canvas>
        </div>
        <h6 class="text-center mb-2">{{transactions_pending}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
      </div>


    </div>


    <div class="box-filter col-6">
      <div class="col-12 searchBox_inner">
        <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>
      </div>
      <table width="100%">
        <tbody>
       <tr>
         <td style="width: 50%"><div class="">
        <div class="dropdown-label-group" >
        <p-dropdown
          class="dv-dropdown"
          selectId="customercode"
          [options]="customercode"
          [(ngModel)]="selectedCustomercode"

          [autoDisplayFirst]="false"
          placeholder="{{'FILTER.CUSTOMER-CODE' | translate}}"
          [style]="{'z-index': 3}"
          filter="true"
        >
        </p-dropdown>
        <label for="customercode">{{'FILTER.CUSTOMER-CODE' | translate}}</label>
      </div>
      </div>
         </td>

         <td width="50%">
           <div >
        <div class="dropdown-label-group mt-0">
        <p-multiSelect
          class="dv-dropdown"
          [options]="rdDocumentType"
          [(ngModel)]="selectedRdDocumentType"
          [panelStyle]="{minWidth: '268px'}"
          [maxSelectedLabels]="1"
          [defaultLabel]="defaultLabel"
        >
        </p-multiSelect>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>
         </td>
       </tr>
        <tr>
        </tr>
        </tbody>
      </table>
      <table width="100%">
        <tbody>
        <tr>
          <td >
            <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside" style="margin-top: -10px">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange"
                 ngbDropdownToggle placeholder="{{'FILTER.DATE-OF-ISSUE' | translate}}" readonly>
          <label for="calendarDropdown">{{'FILTER.DATE-OF-ISSUE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); sentdate(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="stopPropagation($event)">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>

          </td>
          <td class="center" style="width: 30%">
            <div style="padding-top: 5px">
      <div class="form-label-group form-group">
        <input class="form-control" type="text" id="docnum" [(ngModel)]="email"
               placeholder="{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}">
        <label for="documentType">{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}</label>
      </div>
    </div>
          </td><td class="center" style="width: 30%">
            <div style="padding-top: 5px">
      <div class="form-label-group form-group">
        <input class="form-control" type="text" id="email" [(ngModel)]="documentnum"
               placeholder="{{ 'FILTER.DOCUMENT-NUMBER' | translate }}">
        <label for="documentType">{{ 'FILTER.DOCUMENT-NUMBER' | translate }}</label>
      </div>
    </div>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
  </div>

<div class="col-12 box-parent  mt-3 pr-0 pl-0">
  <div class="pl-2">
   <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
  >
  </app-custom-pagination>
  </div>
   <div class="col-12 m-t-20  scrollable padding-left pl-0 pr-0">
    <table class="table text-center" *ngIf="!loading_main">
      <thead >

          <th scope="col">{{'FILTER.DATE' | translate}}</th>
          <th scope="col">{{'FILTER.CUSTOMER-CODE' | translate}}</th>
          <th scope="col">{{'FILTER.DOCUMENT-TYPE' | translate}}</th>
          <th scope="col">{{'FILTER.DOCUMENT-NUMBER' | translate}}</th>
          <th scope="col">{{'NORMAL.EMAIL' | translate}}</th>
          <th scope="col">{{'FILTER.PO-NUMBER' | translate}}</th>
          <th scope="col">{{'EMAIL-DASHBOARD.STATUS' | translate}}</th>
      </thead>
      <tbody >

        <tr *ngFor="let res of datastatus; let i = index" >
            <td class="text-center">{{res.created_at| date:"dd/MM/yyyy"}}</td>
            <td class="text-center">{{res.customer_code}}</td>
            <td class="text-center">{{res.rd_doc_type_display}}</td>
            <td class="text-center">{{res.document_number}}</td>
            <td class="text-center">{{res.email}}</td>
            <td class="text-center">{{res.po_number}}</td>
        <td class="align-top" *ngIf="res.request_status=='Pending'"><i class="fa fa-circle" style="color: #FADA3A" aria-hidden="true"></i></td>
        <td class="align-top" *ngIf="res.request_status=='Rejected'"><i class="fa fa-circle" style="color: #FF6384" aria-hidden="true"></i></td>
        <td class="align-top" *ngIf="res.request_status=='Approve'"><i class="fa fa-circle" style="color: #16c8c8" aria-hidden="true"></i></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row m-t-20" *ngIf="loading_main">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
  </div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard.component.html